<template>
  <div class="main-container">
    <!-- <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;"> -->
    <!-- <h2 style="flex: 1;">Reports</h2> -->

    <!-- </div> -->
    <!-- {{pathList}} -->
    <vk-modal :show.sync="confirmDeleteModal">
      <vk-modal-close @click="confirmDeleteModal = false"></vk-modal-close>

      <!-- <vk-modal-title>Delete Report</vk-modal-title> -->
      <!-- <el-card class="box-card"> -->
      <div style="font-size:17px;">Are you sure you want to delete report?</div>
      <div slot="footer" class="uk-text-right">
        <el-button-group>
          <el-button type="danger" @click="confirmDeleteReport()">Delete</el-button>
          <el-button type="primary" @click="confirmDeleteModal = false">Cancel</el-button>
        </el-button-group>
      </div>
      <!-- </div> -->
      <!-- </el-card> -->
    </vk-modal>

    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>New Report Configuration</h3>
        <hr /> 
        <el-form class="form" ref="form" :model="form">
          <el-form-item>
            <el-input v-model="form.title" placeholder="Title"></el-input>
          </el-form-item>

          <el-form-item>
            <el-select
              v-model="form.endpoint"
              filterable
              placeholder="Endpoint"
              style="width: 100%;"
            >
              <el-option
                v-for="(item, idx ) in pathList"
                :key="`${idx}_endpoint_option${item.path}`"
                :label="item.path"
                :value="item.path"
              ></el-option>
            </el-select>
            <!-- <el-form-item>
            <el-input v-model="form.endpoint" placeholder="Endpoint"></el-input>-->
          </el-form-item>
          <el-form-item>
            <el-input v-model="form.config.include" placeholder="Include Filter" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="formWhere" placeholder="Where Filter" />
          </el-form-item>
          <hr /> 
          <el-form-item
            style="display: flex;"
            v-for="varParam in parameterConfig"
            :key="`dynamic_${varParam['key']}`"
          >
            <el-input v-model="varParam['key']" :disabled="true" style="width: 150px;"></el-input>
            <!-- @change="changeParameterType(varParam,varParam['type'])" -->
            <el-select v-model="varParam['type']" placeholder="Type" style="width: 150px;">
              <el-option label="freetext" value="text"></el-option>
              <el-option label="single option" value="radio"></el-option>
              <el-option label="multi option" value="checkbox"></el-option>
              <el-option label="range" value="range"></el-option>
              <el-option label="date" value="date"></el-option>
            </el-select>
            <!-- v-model="formOptions[varParam]['options']" -->
            <!-- {{formOptions[varParam]}} -->
            <input
              v-model="varParam['options']"
              placeholder="Options"
              class="el-input__inner"
              style="width: 150px;"
            />
            <input
              v-model="varParam['name']"
              placeholder="Name"
              class="el-input__inner"
              style="width: 150px;"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="customer-btn" @click="onSubmit()">Create</el-button>
          </el-form-item>
        </el-form> 
      </div>
    </vk-offcanvas>

    <div style="width: 100%;">
      <div
        class="custom-table-row"
        style="display: flex; flex-flow: row; justify-content: space-between;"
      >
        <el-input
          style="max-width: 200px"
          placeholder="Type something"
          prefix-icon="el-icon-search"
          v-model="searchTerm"
        ></el-input>
        <can I="create" a="installation">
          <span style="display: flex; align-items: center;">
            <button class="btn btn-primary" @click="showOffCanvas = true">New Report</button>
          </span>
        </can>
      </div>

      <vue-good-table
        :lineNumbers="true"
        :columns="columns"
        :rows="reportData"
        :pagination-options="{enabled: true}"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'title'">{{ props.row.title? props.row['title']:'--' }}</span>
          <span
            v-if="props.column.field == 'endpoint'"
          >{{ props.row.endpoint? props.row['endpoint']:'--' }}</span>
          <span v-if="props.column.field == 'actions'" class="fancy">
            <el-button size="mini" type="danger" plain @click="deleteReport(props.row)">Delete</el-button>
          </span>
        </template>
        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  Tag
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";
export default {
  name: "ReportConfig",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-tag": Tag
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      parameterConfig: [],
      formNames: {},
      formWhere: "",
      formOptions: {},
      searchTerm: "",
      operationType: "and",
      pathList: [],
      showOffCanvas: false,
      reportData: null,
      confirmDeleteModal: false,
      rowData: null,
      form: {
        title: "",
        endpoint: "",
        config: {
          where: "",
          parameters: {},
          include: ""
        },
        field: "",
        operation: "",
        inputValue: "",
        dynamicTags: [],
        inputVisible: false
      },
      formResults: [],
      rows: [],
      columns: [
        {
          label: "Title",
          field: "title"
        },
        {
          label: "Endpoint",
          field: "endpoint",
          filterable: true
        },
        {
          label: "Actions",
          field: "actions"
        }
      ]
    };
  },
  computed: {
    computedWhere: {
      get() {
        var regx = /((\$\S+))\b/gi;
        let tmpParam = {
          ...this.form.config.parameters
        };
        this.form.config.parameters = {};
        let foundMatch = this.form.config.where.match(regx);
        if (foundMatch) {
          foundMatch.map(x => {
            if (!tmpParam[x]) {
              this.form.config.parameters[x] = {
                key: x,
                type: "freetext"
              };
              this.formOptions[x] = {
                name: x.replace("$", ""),
                options: ""
              };
            } else {
              this.form.config.parameters[x] = {
                ...tmpParam[x]
              };
            }
          });
          this.form = {
            ...this.form,
            config: this.form.config
          };
          return foundMatch;
        }
      },
      set(newVal, oldVal) {
        console.log({ newVal, oldVal });
      }
    }
  },
  watch: {
    formWhere: function(newVal, oldVal) {
      console.log({ newVal, oldVal });
      var regx = /((\$\S+))\b/gi;
      let foundMatch = newVal.match(regx);
      if (foundMatch) {
        foundMatch.map(x => {
          let entryFound = this.parameterConfig.find(v => v.key == x);
          if (!entryFound) {
            this.parameterConfig = [
              ...this.parameterConfig,
              {
                key: x,
                type: "freetext",
                name: x.replace("$", ""),
                options: ""
              }
            ];
          }
          // else {
          //   this.form.config.parameters[x] = {
          //     ...tmpParam[x]
          //   };
          // }
        });
        // this.form = {
        //   ...this.form,
        //   config: this.form.config
        // };
        // return foundMatch;
      }
    },
    formOptions: function(newVal, oldVal) {
      // console.log("i am newVal",newVal)
      // console.log("i am oldVal",oldVal)
      // console.log({ newVal, oldVal });
      // if (this.map) {
      //   this.map.setOptions({
      //     styles:
      //       this.getTheme["theme-name"] == "dark-solarbase" ? darkStyle : {}
      //   });
      // }
    }
  },
  methods: {
    // updateVal(parnt,chld){
    //   console.log({parnt,chld})
    // },
    addOperation() {
      console.log({
        operation: this.form.operation,
        field: this.form.field,
        operands: this.form.operands
      });
    },
    changeParameterType(key, type) {
      console.log("i am key", key);
      console.log("i am key", type);
      // this.form = {
      //   ...this.form,
      //   config: {
      //     ...this.form.config,
      //     parameters: {
      //       ...this.form.config.parameters,
      //       [key]: { ...this.form.config.parameters[key], type }
      //     }
      //   }
      // };
      // console.log("this is form", this.form);
    },
    changeParameterOptions(key, options) {
      // console.log("i am key", key);
      // console.log("i am key", options);
      this.form = {
        ...this.form,
        config: {
          ...this.form.config,
          parameters: {
            ...this.form.config.parameters,
            [key]: { ...this.form.config.parameters[key], options }
          }
        }
      };
      // console.log("this is form", this.form);
    },
    getReports() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get("/reporting").then(reports => {
        //console.log(JSON.stringify(components.data))
        // container.rows = components.data;
        container.reportData = reports.data;
        // container.reportData.filter(x => {
        //   x.value = x.id;
        //   x.text = x.name;
        // });
      });
    },
    confirmDeleteReport() {
      const container = this;
      const HTTP = this.$httpUtils.instance;
      const url = `/reporting/${this.rowData.id}`;
      HTTP.delete(url)
        .then(response => {
          container.showSuccessMsg({
            message: "1 report config Deleted"
          });
          this.confirmDeleteModal = false;
          this.getReports();
        })
        .catch(error => {
          container.showErrorMsg({
            message: "Error occured!"
          });
        });
    },
    deleteReport(row) {
      this.confirmDeleteModal = true;
      this.rowData = row;
      confirmDeleteReport();
      //console.log(row.id);
      // const container = this;
      // const HTTP = this.$httpUtils.instance;
      // const url = `/reporting/${row.id}`;
      // HTTP.delete(url)
      // .then(response => {
      //   container.showSuccessMsg({
      //     message: "1 report config Deleted"
      //   });
      //   this.getReports();
      // })
      // .catch(error=> {
      //   container.showErrorMsg({
      //     message: "Error occured!"
      //   });
      // })
    },
    updateForm(value) {
      console.log("=======================");
      console.log(value);
      console.log(this.formOptions);
      console.log(this.formNames);
    },
    onSubmit() {
      //console.log("form",this.computedWhere);
      // console.log(this.parameterConfig);
      // console.log(this.formNames);
      let data = {
        title: `${this.form.title}`,
        endpoint: `${this.form.endpoint}`,
        config: {
          ...this.form.config,
          where: this.formWhere,
          parameters: this.parameterConfig
        }
      };

      // console.log({ data });
      const container = this;
      const HTTP = this.$httpUtils.instance;
      const url = `/reporting`;
      HTTP.post(url, data)
        .then(response => {
          container.showSuccessMsg({
            message: "Report config added"
          });
          this.showOffCanvas = false;
          this.getReports();
        })
        .catch(error => {
          container.showErrorMsg({
            message: "Error occured!"
          });
        });
    }
  },
  mounted() {
    this.getReports();
    this.$httpUtils.explorerHTTP
      .get("")
      .then(x => x.data)
      .then(apiData => {
        // console.log(apiData);
        this.pathList = Object.keys(apiData.paths)
          .map(x => {
            // console.log(apiData.paths[x]);
            return apiData.paths[x].hasOwnProperty("get")
              ? {
                  ...apiData.paths[x],
                  path: x
                }
              : false;
          })
          .filter(x => x);
        console.log(this.pathList);
      });
  }
};
</script> 


// WEBPACK FOOTER //
// src/components/pages/report/config.vue